import { render, staticRenderFns } from "./CompartilharLaudo.vue?vue&type=template&id=12b85476&"
import script from "./CompartilharLaudo.vue?vue&type=script&lang=js&"
export * from "./CompartilharLaudo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports